import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import { config } from '../../config.js'
import { checkMark, verticalLogo } from '../../images/images.js'
import { Page, FullHeightCenteredFlexColumn, CenteredFlexColumn, Logo } from '../styles/Containers.js'
import BodyText, { BoldSpan, LargeTitle } from '../styles/Text.js'

const CheckMark = styled.img`
  width: 180px;
  align-items: center;
`

const SubContentContainer = styled(CenteredFlexColumn)`
  gap: 15px;
`

const FixedContainer = styled.div`
  position: absolute;
  left: 5%;
  top: 50px;
  z-index: 10;
`

function ConfirmationTemplate({ title, bodyText, children, showLogo = false, showContact = false }) {
  return (
    <Page>
      {showLogo && (
        <FixedContainer>
          <Logo src={verticalLogo} />
        </FixedContainer>
      )}
      <FullHeightCenteredFlexColumn>
        <CheckMark src={checkMark} />
        <LargeTitle>{title}</LargeTitle>
        <SubContentContainer>
          {bodyText.map((t, i) => (
            <BodyText key={i}>{t}</BodyText>
          ))}
          {children}
          {showContact && (
            <BodyText>
              Contact us at <BoldSpan>{config.foi.privacyTeamEmail}</BoldSpan> with any questions.
            </BodyText>
          )}
        </SubContentContainer>
      </FullHeightCenteredFlexColumn>
    </Page>
  )
}

ConfirmationTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  bodyText: PropTypes.array,
  children: PropTypes.node,
  showLogo: PropTypes.bool,
  showContact: PropTypes.bool
}

export default ConfirmationTemplate
